import {
    CircularProgress,
    ClickAwayListener,
    Grid,
    Popper,
    TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { portExpTariffVariables } from "../../../constants";
import { Autocomplete } from "@material-ui/lab";
import { RxCross2 } from "react-icons/rx";
import TariffDownloadPdf from "./tariffPdfDownload";
import TariffUploadPDFModal from "./tariffPdfUpload";
import { GrDocumentPdf } from "react-icons/gr";


const options = ["GRT", "NRT", "Hours", "fixed", "Cargo Quantity", "Other Multiplier", "Day"];
function TariffTemplate({
    tariffData,
    onInputChange,
    onAddRow,
    onDeleteRow,
    onRowChange,
    portOptions,
    portLoading,
    delayPortSearch,
    selectednewPort,
    onChangenewPort,
    onDownloadPdf,
    editTariffTemplate = false,
    setTariffData,
}) {
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
    const [getOpenUploadPDF, setOpenUploadPDF] = useState(false);

    const handleCloseDropdown = () => {
        setDropdownAnchorEl(null);
        setOpenDropdownIndex(null);
    };

    const toggleDropdown = (event, index) => {
        if (openDropdownIndex === index) {
            handleCloseDropdown();
        } else {
            setDropdownAnchorEl(event.currentTarget);
            setOpenDropdownIndex(index);
        }
    };

    const toggleOption = (index, option) => {
        const currentSelected = tariffData.parforma_port_tariff[index].factors || [];
        const isSelected = currentSelected.includes(option);

        let newSelectedValues;
        if (isSelected) {
            newSelectedValues = currentSelected.filter(item => item !== option);
        } else {
            newSelectedValues = [...currentSelected, option];
        }

        onRowChange(index, "factors", newSelectedValues);
    };

    const handleDelete = (index, itemToDelete) => () => {
        const newSelectedValues = tariffData.parforma_port_tariff[
            index
        ].factors.filter((item) => item !== itemToDelete);
        onRowChange(index, "factors", newSelectedValues);
    };

    useEffect(() => {
        if (!dropdownAnchorEl) return;
        const handleScroll = () => {
            handleCloseDropdown();
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [dropdownAnchorEl]);

    return (
        <div className="tariff-template-compact w-full">
            <style>{`
                div[data-factors-dropdown] {
                    scrollbar-width: thin !important;
                    scrollbar-color: #94a3b8 #f1f5f9 !important;
                }
                div[data-factors-dropdown]::-webkit-scrollbar {
                    width: 5px !important;
                }
                div[data-factors-dropdown]::-webkit-scrollbar-track {
                    background: #f1f5f9 !important;
                }
                div[data-factors-dropdown]::-webkit-scrollbar-thumb {
                    background-color: #94a3b8 !important;
                    border-radius: 4px !important;
                }
                div[data-factors-dropdown]::-webkit-scrollbar-thumb:hover {
                    background-color: #64748b !important;
                }
                .tariff-template-compact .compact-port-select {
                    height: 19.5px !important;
                    min-height: 19.5px !important;
                    width: 100% !important;
                    background: #ffffd6 !important;
                }
                .tariff-template-compact .compact-port-select .MuiInput-root {
                    height: 19.5px !important;
                    min-height: 19.5px !important;
                    padding: 0 18px 0 4px !important;
                    font-size: 11px !important;
                    background: #ffffd6 !important;
                    width: 100% !important;
                }
                .tariff-template-compact .compact-port-select .MuiInput-root.Mui-focused {
                    background: #ffffff !important;
                }
                .tariff-template-compact .compact-port-select .MuiInput-input {
                    height: 19.5px !important;
                    padding: 0 !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                    line-height: 19.5px !important;
                    color: #000000 !important;
                    box-sizing: border-box !important;
                }
                .tariff-template-compact .compact-port-select .MuiAutocomplete-endAdornment {
                    top: 50% !important;
                    transform: translateY(-50%) !important;
                    right: 2px !important;
                }
                .tariff-template-compact .compact-port-select .MuiIconButton-root {
                    padding: 1px !important;
                }
                .tariff-template-compact .compact-port-select .MuiSvgIcon-root {
                    font-size: 14px !important;
                    color: #475569 !important;
                }
                .tariff-template-compact .fleet-result-table td input {
                    background-color: #ffffd6 !important;
                    text-align: left !important;
                }
                .tariff-template-compact .fleet-result-table td input:focus {
                    background-color: #ffffff !important;
                    text-align: left !important;
                }
                .tariff-template-compact table input {
                    display: block !important;
                    width: 100% !important;
                    height: 19px !important;
                    min-height: 19px !important;
                    max-height: 19px !important;
                    line-height: 19px !important;
                    outline: none !important;
                    border: none !important;
                    box-shadow: none !important;
                    box-sizing: border-box !important;
                    margin: 0 !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                }
                .tariff-template-compact table input:focus,
                .tariff-template-compact table select:focus {
                    outline: 1.5px solid #d97706 !important;
                    outline-offset: -1.5px !important;
                    background-color: #ffffff !important;
                    border: none !important;
                    box-shadow: none !important;
                }
                .tariff-template-compact table td:has(input:focus),
                .tariff-template-compact table td:has(select:focus) {
                    background-color: #ffffff !important;
                }
                .tariff-template-compact input[type=number]::-webkit-inner-spin-button, 
                .tariff-template-compact input[type=number]::-webkit-outer-spin-button { 
                    -webkit-appearance: none !important;
                    margin: 0 !important;
                }
                .tariff-template-compact input[type=number] {
                    -moz-appearance: textfield !important;
                }
                .tariff-template-compact .compact-port-select.Mui-focused,
                .tariff-template-compact .compact-port-select .MuiInput-root.Mui-focused {
                    outline: 1.5px solid #d97706 !important;
                    outline-offset: -1.5px !important;
                    background-color: #ffffff !important;
                    box-shadow: none !important;
                }
                .compact-port-popper .MuiAutocomplete-paper {
                    margin-top: 1px !important;
                    border: 1px solid #cbd5e1 !important;
                    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1) !important;
                    border-radius: 0px !important;
                }
                .compact-port-popper .MuiAutocomplete-option {
                    font-size: 11px !important;
                    min-height: 20px !important;
                    padding: 2px 6px !important;
                    color: #000000 !important;
                    font-weight: 500 !important;
                }
            `}</style>

            <Grid container spacing={1} className="w-full !m-0 !p-0">
                {/* Top Section: Tariff Name, Upload PDF, Description */}
                <Grid item xs={12}>
                    <div className="flex flex-col gap-1 bg-slate-50 border border-slate-200 p-1.5 rounded-none">
                        <div className="flex justify-between items-center gap-2">
                            <div className="flex items-center gap-2 flex-1">
                                <label className="text-[11px] font-medium text-slate-800 whitespace-nowrap min-w-[95px]">
                                    Tariff Name
                                </label>
                                <input
                                    type="text"
                                    className="h-[22px] text-[11px] font-medium px-2 border border-slate-300 rounded-none bg-white focus:border-[#d97706] focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1px] focus:ring-0 outline-none w-full max-w-[320px]"
                                    placeholder="Enter Tariff name"
                                    value={tariffData.tariff_name}
                                    onChange={(e) => onInputChange("tariff_name", e.target.value)}
                                />
                            </div>
                            <div>
                                {editTariffTemplate ? (
                                    <TariffDownloadPdf pdfData={tariffData} onDownloadPdf={onDownloadPdf} />
                                ) : (
                                    <button
                                        type="button"
                                        className="h-[22px] px-2.5 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium flex items-center gap-1.5 border border-[#313C4C] rounded-none cursor-pointer transition-colors shadow-2xs"
                                        onClick={() => setOpenUploadPDF(true)}
                                    >
                                        <GrDocumentPdf size={12} />
                                        <span>Upload PDF</span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="flex items-start gap-2">
                            <label className="text-[11px] font-medium text-slate-800 whitespace-nowrap min-w-[95px] pt-0.5">
                                Tariff Description
                            </label>
                            <textarea
                                rows="2"
                                placeholder="Enter Tariff description"
                                className="flex-1 h-[34px] text-[11px] font-medium px-2 py-1 border border-slate-300 rounded-none bg-white focus:border-[#d97706] focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1px] focus:ring-0 outline-none resize-none"
                                value={tariffData.tariff_description}
                                maxLength={250}
                                onChange={(e) => onInputChange("tariff_description", e.target.value)}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Left Table: Non-tech Variables */}
                <Grid item xs={6}>
                    <table className="fleet-result-table">
                        <tbody>
                            {portExpTariffVariables?.nonTechVars?.map((item, key) => (
                                <tr key={key}>
                                    <th>{item.label}</th>
                                    <td className="bg-[#ffffd6]">
                                        {item.name === "port" ? (
                                            <Autocomplete
                                                options={portOptions || []}
                                                value={selectednewPort?.portLabel ? selectednewPort : (selectednewPort?.selectedPort?.portLabel ? selectednewPort?.selectedPort : null)}
                                                getOptionLabel={(option) => option?.portLabel || ""}
                                                disableClearable
                                                classes={{ popper: "compact-port-popper" }}
                                                onChange={(e, value) => {
                                                    onChangenewPort("port", value);
                                                    onInputChange(item.name, value);
                                                }}
                                                className="compact-port-select w-full"
                                                blurOnSelect
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Search Port"
                                                        onChange={(e) => delayPortSearch(e.target.value)}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            disableUnderline: true,
                                                            endAdornment: (
                                                                <>
                                                                    {portLoading && <CircularProgress color="inherit" size={11} />}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <input
                                                type={item.type}
                                                name={item.name}
                                                value={tariffData[item.name] || ""}
                                                onChange={(e) => onInputChange(item.name, e.target.value)}
                                                className="w-full h-full text-[11px] font-medium px-1.5 bg-[#ffffd6] focus:bg-white border-0 outline-none text-slate-800 focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0"
                                            />
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Grid>

                {/* Right Table: Tech Variables */}
                <Grid item xs={6}>
                    <table className="fleet-result-table">
                        <tbody>
                            {portExpTariffVariables?.techVars?.map((item, key) => (
                                <tr key={key}>
                                    <th>
                                        {item.label === "Exchange Rate"
                                            ? `Exchange Rate (${tariffData?.tariff_rate_currency || "USD"} to ${tariffData?.local_currency || "Local"})`
                                            : item.label}
                                    </th>
                                    <td className="bg-[#ffffd6]">
                                        <input
                                            type="number"
                                            name={item.name}
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            value={tariffData[item.name] ?? ""}
                                            onChange={(e) => onInputChange(item.name, e.target.value)}
                                            className="w-full h-full text-[11px] font-medium px-1.5 bg-[#ffffd6] focus:bg-white border-0 outline-none text-slate-800 text-left focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Grid>

                {/* Main Tariff Calculation Table */}
                <Grid item xs={12}>
                    <div className="w-full overflow-x-auto border border-slate-300 rounded-none" onScroll={handleCloseDropdown}>
                        <table className="w-full border-collapse bg-white text-[11px]">
                            <thead>
                                <tr className="bg-[#f1f5f9] border-b border-slate-300 h-[20px] text-slate-900 text-[11px] font-medium leading-[19px]">
                                    <th className="w-[22px] p-0 text-center border-r border-slate-300 bg-[#f1f5f9]"></th>
                                    <th className="min-w-[190px] px-1.5 py-0 text-left font-medium border-r border-slate-300 bg-[#f1f5f9]">Label</th>
                                    <th className="w-[60px] px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] whitespace-nowrap">Unit Rate</th>
                                    <th className="w-[190px] px-1.5 py-0 text-left font-medium border-r border-slate-300 bg-[#f1f5f9]">Factors</th>
                                    <th className="w-[92px] px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] whitespace-nowrap">Net Amount ({tariffData?.local_currency || "Local"})</th>
                                    <th className="w-[48px] px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] whitespace-nowrap">Tax (%)</th>
                                    <th className="w-[88px] px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] whitespace-nowrap">Gross ({tariffData?.local_currency || "Local"})</th>
                                    <th className="w-[80px] px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] whitespace-nowrap">Gross ({tariffData?.tariff_rate_currency || "USD"})</th>
                                    <th className="w-[22px] p-0 text-center bg-[#f1f5f9]"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {tariffData?.parforma_port_tariff?.map((row, index) => {
                                    return (
                                        <tr key={index} className="border-b border-slate-300 h-[19px] hover:bg-slate-50/50">
                                            <td className="w-[22px] p-0 text-center align-middle border-r border-slate-300 bg-white h-[19px]">
                                                <button
                                                    type="button"
                                                    className="w-3.5 h-3.5 leading-none rounded-none text-sky-600 hover:text-sky-800 hover:bg-sky-50 flex items-center justify-center text-[13px] border-none bg-transparent mx-auto transition-colors cursor-pointer p-0"
                                                    onClick={() => onAddRow(index)}
                                                    title="Add row below"
                                                >
                                                    +
                                                </button>
                                            </td>
                                            <td className="min-w-[190px] p-0 border-r border-slate-300 bg-[#ffffd6] h-[19px]">
                                                <input
                                                    type="text"
                                                    value={row.label}
                                                    placeholder="Enter label"
                                                    onChange={(e) => onRowChange(index, "label", e.target.value)}
                                                    className="w-full h-[19px] leading-[19px] text-[11px] font-medium px-1.5 border-0 outline-none bg-[#ffffd6] focus:bg-white text-slate-800 focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0"
                                                />
                                            </td>
                                            <td className="w-[60px] p-0 border-r border-slate-300 bg-[#ffffd6] h-[19px]">
                                                <input
                                                    type="number"
                                                    value={row.unitRate ?? 0}
                                                    onWheel={(e) => e.target.blur()}
                                                    min={0}
                                                    onChange={(e) => onRowChange(index, "unitRate", e.target.value)}
                                                    className="w-full h-[19px] leading-[19px] text-[11px] font-medium px-1 border-0 outline-none bg-[#ffffd6] focus:bg-white text-slate-800 text-right focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0"
                                                />
                                            </td>
                                            <td className="w-[190px] p-0 border-r border-slate-300 bg-[#ffffd6] h-[19px] align-middle">
                                                <div
                                                    className={`flex flex-wrap items-center gap-0.5 border-0 outline-none ${openDropdownIndex === index ? 'bg-white outline outline-[1.5px] outline-[#d97706] -outline-offset-[1.5px]' : 'bg-[#ffffd6] hover:bg-[#fff9a6]'} cursor-pointer min-h-[19px] px-1 py-0 rounded-none w-full`}
                                                    onClick={(e) => toggleDropdown(e, index)}
                                                >
                                                    {!row.factors || row.factors.length === 0 ? (
                                                        <span className="text-slate-400 text-[10px] leading-[18px]">Select factors...</span>
                                                    ) : (
                                                        <>
                                                            {row.factors.map((option, optIndex) => (
                                                                <div
                                                                    key={optIndex}
                                                                    className="inline-flex items-center gap-0.5 bg-white text-slate-800 rounded-none px-1 py-0 h-[15px] text-[10px] leading-[15px] border border-slate-300/80 my-[1px]"
                                                                >
                                                                    <span>{option}</span>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleDelete(index, option)();
                                                                        }}
                                                                        className="text-slate-400 hover:text-rose-600 border-none bg-transparent p-0 flex items-center cursor-pointer leading-none"
                                                                    >
                                                                        <RxCross2 size={9} />
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="w-[92px] px-1 py-0 text-right font-medium border-r border-slate-300 text-slate-800 bg-white tabular-nums h-[19px] leading-[19px]">
                                                {row.netAmount ? row.netAmount?.toFixed(2) : 0}
                                            </td>
                                            <td className="w-[48px] p-0 border-r border-slate-300 bg-[#ffffd6] h-[19px]">
                                                <input
                                                    type="number"
                                                    min={0}
                                                    value={row.tax ?? 0}
                                                    onWheel={(e) => e.target.blur()}
                                                    onChange={(e) => onRowChange(index, "tax", e.target.value)}
                                                    className="w-full h-[19px] leading-[19px] text-[11px] font-medium px-1 border-0 outline-none bg-[#ffffd6] focus:bg-white text-slate-800 text-right focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:ring-0"
                                                />
                                            </td>
                                            <td className="w-[88px] px-1 py-0 text-right font-medium border-r border-slate-300 text-slate-800 bg-white tabular-nums h-[19px] leading-[19px]">
                                                {row.gross_local && row?.factors?.length ? row.gross_local?.toFixed(2) : 0}
                                            </td>
                                            <td className="w-[80px] px-1 py-0 text-right font-medium border-r border-slate-300 text-slate-800 bg-white tabular-nums h-[19px] leading-[19px]">
                                                {row.gross_tariff && row?.factors?.length && tariffData?.exchange_rate ? row.gross_tariff?.toFixed(2) : 0}
                                            </td>
                                            <td className="w-[22px] p-0 text-center align-middle bg-white h-[19px]">
                                                <button
                                                    type="button"
                                                    className="w-3.5 h-3.5 leading-none rounded-none text-rose-500 hover:text-rose-700 hover:bg-rose-50 flex items-center justify-center text-[13px] border-none bg-transparent mx-auto transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed p-0"
                                                    onClick={() => onDeleteRow(index)}
                                                    disabled={tariffData.parforma_port_tariff.length <= 1}
                                                    title="Delete row"
                                                >
                                                    ×
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr className="bg-[#f1f5f9] border-t border-slate-300 h-[20px] text-[11px] font-medium text-slate-900 leading-[19px]">
                                    <td colSpan={3} className="border-r border-slate-300 bg-[#f1f5f9]"></td>
                                    <td className="px-1.5 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9]">Total:</td>
                                    <td className="px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] tabular-nums">
                                        {tariffData?.net_amount ? tariffData?.net_amount?.toFixed(2) : 0}
                                    </td>
                                    <td className="border-r border-slate-300 bg-[#f1f5f9]"></td>
                                    <td className="px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] tabular-nums">
                                        {tariffData?.total_gross ? tariffData.total_gross?.toFixed(2) : 0}
                                    </td>
                                    <td className="px-1 py-0 text-right font-medium border-r border-slate-300 bg-[#f1f5f9] tabular-nums">
                                        {tariffData?.total_exchange_rate && tariffData?.exchange_rate ? tariffData.total_exchange_rate?.toFixed(2) : 0}
                                    </td>
                                    <td className="bg-[#f1f5f9]"></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </Grid>

                {/* Bottom Notes & Description */}
                <Grid item xs={6}>
                    <div className="flex flex-col gap-0.5">
                        <label className="text-[11px] font-medium text-slate-800">
                            Tariff Structure Explanatory Notes
                        </label>
                        <textarea
                            className="w-full text-[11px] font-medium border border-slate-300 rounded-none p-1.5 focus:border-[#d97706] focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1px] focus:ring-0 outline-none resize-y min-h-[90px] placeholder:text-[11px] placeholder:text-slate-400 leading-normal"
                            placeholder="Detail Explanatory Notes about this Tariff Structure"
                            rows="5"
                            maxLength={250}
                            value={tariffData.tariff_structure_details}
                            onChange={(e) => onInputChange("tariff_structure_details", e.target.value)}
                        />
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <div className="flex flex-col gap-0.5">
                        <label className="text-[11px] font-medium text-slate-800">
                            Port Information Description
                        </label>
                        <textarea
                            className="w-full text-[11px] font-medium border border-slate-300 rounded-none p-1.5 focus:border-[#d97706] focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1px] focus:ring-0 outline-none resize-y min-h-[90px] placeholder:text-[11px] placeholder:text-slate-400 leading-normal"
                            placeholder="Text Description of the Port Information"
                            rows="5"
                            maxLength={4000}
                            value={tariffData.port_description}
                            onChange={(e) => onInputChange("port_description", e.target.value)}
                        />
                    </div>
                </Grid>
            </Grid>

            <TariffUploadPDFModal
                open={getOpenUploadPDF}
                handleClose={() => setOpenUploadPDF(false)}
                setQuery={setTariffData}
                query={tariffData}
            />

            <Popper
                open={Boolean(dropdownAnchorEl && openDropdownIndex !== null)}
                anchorEl={dropdownAnchorEl}
                placement="bottom-start"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'viewport',
                        padding: 8,
                    },
                }}
                style={{ zIndex: 1500 }}
            >
                <ClickAwayListener
                    onClickAway={(event) => {
                        if (dropdownAnchorEl && dropdownAnchorEl.contains(event.target)) {
                            return;
                        }
                        handleCloseDropdown();
                    }}
                >
                    <div
                        data-factors-dropdown
                        className="min-w-[210px] w-max max-w-[270px] bg-white border border-slate-300 shadow-xl max-h-48 overflow-y-auto py-0.5 rounded-none scroll-thin"
                    >
                        {openDropdownIndex !== null && tariffData?.parforma_port_tariff?.[openDropdownIndex] && (
                            options.map((option, optIndex) => {
                                const row = tariffData.parforma_port_tariff[openDropdownIndex];
                                const isSelected = row?.factors && row.factors.includes(option);
                                return (
                                    <div
                                        key={optIndex}
                                        className={`flex items-center justify-between px-2.5 py-1 text-[11px] whitespace-nowrap hover:bg-slate-100 cursor-pointer ${isSelected ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-700'}`}
                                        onClick={() => toggleOption(openDropdownIndex, option)}
                                    >
                                        <div className="flex items-center gap-2 whitespace-nowrap">
                                            <input
                                                type="checkbox"
                                                checked={isSelected || false}
                                                onChange={() => { }}
                                                className="h-3.5 w-3.5 rounded-none border-slate-300 cursor-pointer accent-[#313C4C]"
                                            />
                                            <span className="whitespace-nowrap select-none">{option}</span>
                                        </div>
                                        {isSelected && (
                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDelete(openDropdownIndex, option)();
                                                }}
                                                className="text-slate-400 hover:text-rose-600 border-none bg-transparent p-0 flex items-center cursor-pointer ml-2"
                                            >
                                                <RxCross2 size={11} />
                                            </button>
                                        )}
                                    </div>
                                );
                            })
                        )}
                    </div>
                </ClickAwayListener>
            </Popper>
        </div>
    );
}

export default TariffTemplate;
